var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365-96q-12 0-21.5-7T330-121l-98-323H132q-15 0-25.5-10.5T96-480q0-15 10.5-25.5T132-516h127q12 0 21.5 7t13.5 18l66 217 123-562q2-13 12-20.5t23-7.5q13 0 22.5 8t12.5 20l86 372 56-182q3-11 12.5-18t21.5-7q11-1 20.5 5.5T763-648l49 132h16q15 0 25.5 10.5T864-480q0 15-10.5 25.5T828-444h-41q-11 0-20-6.5T754-468l-22-55-64 208q-4 12-14 19.5t-22 6.5q-12 0-21.5-8T599-317l-80-347-119 540q-2 12-12 19.5T365-96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/pulse.801d059a5b51229afeb26cd5be17dbb3.svg";
export { ForwardRef as ReactComponent };